"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _constants = require("./assets/constants");
// Types

// Constants

var HotelNotice = function HotelNotice(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement(StyledHotelNotice, null, /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], {
    skipHtml: true,
    unwrapDisallowed: true,
    allowElement: function allowElement(element) {
      return _constants.allowedNodeTypes.includes(element.tagName);
    }
  }, text));
};
var StyledHotelNotice = _styledComponents["default"].div.withConfig({
  displayName: "HotelNotice__StyledHotelNotice",
  componentId: "sc-11snli2-0"
})(["padding:7px 9px 9px;font-size:12px;background-color:var(--background);border-radius:var(--border-radius);> a{color:var(--secondary);text-decoration:none;}"]);
var _default = exports["default"] = HotelNotice;